import ConfirmModal from "../../../components/ConfirmModal";
import {useDispatch, useSelector} from "react-redux";
import {setManageBlogModals, tryDeleteBlogTag, tryUpdateBlogContents} from "../../../redux/slices/manageBlogSlice";
import {capitalizeFirstLetter} from "../../../helpers/stringHelper";
import {BLOG_STATE_ACTIVE} from "../constants";

const ManageBlogsConfirmModal = () => {

  const dispatch = useDispatch();
  const {modal, data} = useSelector((state => state.manageBlogs.modals.confirmBlog));
  const {
    loading: editing
  } = useSelector((state) => state.dynamicElements.editing);


  const onConfirm = () => {

    dispatch(tryUpdateBlogContents());

  };

  return (
    <ConfirmModal
      title={data?.state ? `Change Status to ${capitalizeFirstLetter(data.state)}?` : ''}
      showModal={modal}
      setShowModal={() => dispatch(setManageBlogModals())}
      disabled={editing}
      buttonLabel="Ok"
      onConfirm={onConfirm}
    >


      <div>
        Are you sure you want to change the status of this blog to "<strong>{capitalizeFirstLetter(data?.state)}</strong>"?
        <div className="text-sm mt-1">
          <strong>Note:</strong> {data?.state === BLOG_STATE_ACTIVE ? "This blog will be public." : "No one will be able to access this blog."}
        </div>
      </div>


    </ConfirmModal>
  );
};

export default ManageBlogsConfirmModal;
